import { Module } from '../Module';

interface TbTranscludeFnAttributes extends ng.IAttributes {
  tbTranscludeFn: string;
  tbTranscludeScope: string;
}

Module.instance().directive('tbTranscludeFn', () => {
  return {
    restrict: 'A',
    link: (scope: ng.IScope, element: JQuery, attrs: TbTranscludeFnAttributes) => {
      let currentClone = $();
      let childScope: ng.IScope;

      scope.$watch(attrs.tbTranscludeFn, (fn: ng.ITranscludeFunction) => {
        currentClone.remove();
        if (childScope) childScope.$destroy();

        if(!fn) return;

        const extraProperties = scope.$eval(attrs.tbTranscludeScope);

        fn((clone: JQuery, scope: ng.IScope) => {
          angular.extend(scope, extraProperties);
          currentClone = clone;
          childScope = scope;
          element.append(currentClone);
        });
      });

      scope.$on('$destroy', () => {
        if (childScope) childScope.$destroy();
      });
    }
  };
});
